import React from 'react';
import './SignInButton.scss';

export const SignInButton = (props) => {
  const { } = props;
  return (
    <div className='signin-button' onClick={() => { window.location.href = 'https://sbd.constlending.com' }}>
      <span>Sign in</span>
    </div>
  );
}
